import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../../../shared/helpers';
import { Badge, BadgeColors, BadgeShapes } from '../../../../generic/Badge';
import Flex from '../../../../generic/Flex';
import List from '../../../../generic/List';

type Props = {
  count: number;
  isLoading: boolean;
};

/**
 * ReleaseGroupReleasesListHeader is a List.Header which displays the total
 * count of releases (not just the ones on this page).
 */
const ReleaseGroupReleasesListHeader: VoidFunctionComponent<Props> = ({
  count,
  isLoading,
}) => (
  <List.Header hasEvenPadding>
    <List.HeaderText>
      <Flex justify="flex-start" gap="4px">
        <span className="margin-right-xs">
          {plural(count, 'Release')}
        </span>
        <Badge shape={BadgeShapes.Circle} color={BadgeColors.LightGray}>
          {isLoading ? '...' : (count || 0)}
        </Badge>
      </Flex>
    </List.HeaderText>
  </List.Header>
);

export default ReleaseGroupReleasesListHeader;
